import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextField } from 'src/components/mui-overrides/Textfield';
import { useInsertDefaultAdornment } from '../../../hooks/useInsertDefaultAdornment';

interface Props {
  disabled?: boolean;
}

const fieldName = 'investmentDetails.landRegisterMortgageStatusText';

export const LandRegisterMortgageStatusText: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();
  const adornment = useInsertDefaultAdornment(
    fieldName,
    t('dashboard.assets.addedit.investment.investmentterms.fields.landRegisterMortgageStatusText.placeholder'),
  );
  return (
    <DefaultFastTextField
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.investmentterms.fields.landRegisterMortgageStatusText.label')}
      fieldName={fieldName}
      placeholder={t('dashboard.assets.addedit.investment.investmentterms.fields.landRegisterMortgageStatusText.placeholder')}
      formik={formik}
      endAdornment={adornment}
    />
  );
};
